import { STUDENT_PRE_CHECK_STATUS } from "../constants";
import { CHECKED_ITEMS } from '../constants'

// potential bug here, it might not be the whole checked items all the time, right now it is because network speed check is the only async
// check in the array, and is always running.
export default function isWaitingOnAsyncChecks(studentPreChecks){
    const allChecks = Object.keys(studentPreChecks.contextStates.checks)
    return CHECKED_ITEMS.length === allChecks.length && allChecks.every(( item ) =>
        studentPreChecks.contextStates.checks[item] === STUDENT_PRE_CHECK_STATUS.success ||
        studentPreChecks.contextStates.checks[item] === STUDENT_PRE_CHECK_STATUS.async_pending)
}